export function splitContactLines(address: string) {
  return address
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean);
}

export function buildGoogleMapsEmbedUrl(address: string) {
  const normalizedAddress = address.trim();
  if (!normalizedAddress) {
    return null;
  }

  return `https://www.google.com/maps?q=${encodeURIComponent(normalizedAddress)}&output=embed`;
}

export function toExternalUrl(url: string) {
  return /^https?:\/\//i.test(url) ? url : `https://${url}`;
}

export function normalizeWhatsAppPhoneNumber(phoneNumber: string) {
  const trimmedValue = phoneNumber.trim();
  if (!trimmedValue) {
    return null;
  }

  const digitsOnly = trimmedValue.replace(/[^\d+]/g, "");
  if (!digitsOnly) {
    return null;
  }

  if (digitsOnly.startsWith("+")) {
    return digitsOnly.slice(1);
  }

  if (digitsOnly.startsWith("00")) {
    return digitsOnly.slice(2);
  }

  if (digitsOnly.startsWith("0")) {
    return `44${digitsOnly.slice(1)}`;
  }

  return digitsOnly;
}

export function buildWhatsAppUrl(phoneNumber: string) {
  const normalizedPhoneNumber = normalizeWhatsAppPhoneNumber(phoneNumber);
  if (!normalizedPhoneNumber) {
    return null;
  }

  return `https://wa.me/${normalizedPhoneNumber}`;
}
